export const checkSubscription = (subscriptions, str) => {
    
    return (subscriptions || []).includes(str);
}